import { Attribute } from './Attribute.js';

export const VOLUME_ATTRIBUTE_TYPE = 'VolumeAttribute';
export const VOLUME_ATTRIBUTE_ID = 'Volume';

// Specific for Volume attribute in Prima Kids credit service
export const PRIMA_KIDS_MINIMAL_REMAINING_MONTHLY_LIMIT = 3;

/**
 *
 * @property {number} value
 * @property {boolean} isReadOnly
 */
export class VolumeAttribute extends Attribute {
  constructor({ value, isReadOnly = false }) {
    super();
    this.value = value;
    this.isReadOnly = isReadOnly;
    this.type = VOLUME_ATTRIBUTE_TYPE;
  }
}
